import React from 'react';

/**
 * Componente para mostrar estadísticas del dashboard de técnico
 * @param {Array} tasks - Array de tareas
 */
function TaskStats({ tasks }) {
    return (
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-2 sm:gap-4 mb-4 sm:mb-6">
            <div className="bg-surface rounded-lg sm:rounded-xl shadow-md border border-line p-2 sm:p-4 text-center">
                <div className="text-lg sm:text-xl md:text-2xl font-bold text-content">{tasks.length}</div>
                <div className="text-xs sm:text-sm text-content-muted">Total Tareas</div>
            </div>
            <div className="bg-surface rounded-lg sm:rounded-xl shadow-md border border-line p-2 sm:p-4 text-center">
                <div className="text-lg sm:text-xl md:text-2xl font-bold text-st-pendiente">
                    {tasks.filter(t => t.status === 'pendiente').length}
                </div>
                <div className="text-xs sm:text-sm text-content-muted">Pendientes</div>
            </div>
            <div className="bg-surface rounded-lg sm:rounded-xl shadow-md border border-line p-2 sm:p-4 text-center">
                <div className="text-lg sm:text-xl md:text-2xl font-bold text-st-en-camino">
                    {tasks.filter(t => t.status === 'en_camino').length}
                </div>
                <div className="text-xs sm:text-sm text-content-muted">En Camino</div>
            </div>
            <div className="bg-surface rounded-lg sm:rounded-xl shadow-md border border-line p-2 sm:p-4 text-center">
                <div className="text-lg sm:text-xl md:text-2xl font-bold text-st-finalizada">
                    {tasks.filter(t => t.status === 'finalizada').length}
                </div>
                <div className="text-xs sm:text-sm text-content-muted">Completadas</div>
            </div>
        </div>
    );
}

export default TaskStats;
